import { render, staticRenderFns } from "./WelcomeLayout.vue?vue&type=template&id=5e146461&scoped=true&"
import script from "./WelcomeLayout.vue?vue&type=script&lang=ts&"
export * from "./WelcomeLayout.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeLayout.vue?vue&type=style&index=0&id=5e146461&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e146461",
  null
  
)

export default component.exports